import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Modal from "@/features/shared/components/Modal/Modal";
import CityTableFilters from "@/features/city/components/CityTableFilters";
import CityTable from "@/features/city/components/CityTable";
import CityPagination from "@/features/city/components/CityPagination";
import CityForm from "@/features/city/components/CityForm";
import useCities from "@/features/city/hooks/useCities";
import { toast } from "react-toastify";
const CitiesPage = () => {
    const [filters, setFilters] = useState({ label: '', region: '' });
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedCity, setSelectedCity] = useState(null);
    const [errors, setErrors] = useState(null);
    // Use the react-query hook, passing currentPage and filters so that the query key changes automatically
    const { cities, regions, meta, loading, error, handleAddCity, handleUpdateCity, handleDeleteCity, refetchCities, } = useCities(currentPage, filters, false, rowsPerPage);
    // Filter changes -> updates state, triggers re-fetch
    const handleFilterChange = (filterName, value) => {
        setFilters((prev) => ({ ...prev, [filterName]: value }));
        setCurrentPage(1); // Reset to first page on filter change
    };
    const handleResetFilters = () => {
        setFilters({ label: '', region: '' });
    };
    // Open modal for adding a new city
    const handleAddCityClick = () => {
        setSelectedCity(null);
        setIsModalVisible(true);
    };
    const handleDelete = async (idCity) => {
        try {
            setErrors(null);
            await handleDeleteCity(idCity);
            toast.success("Ville supprimée");
        }
        catch (error) {
            setErrors(error.message);
            toast.error(`Erreur : ${error.message}`);
        }
    };
    // Open modal for editing an existing city
    const handleEdit = (city) => {
        setSelectedCity(city);
        setIsModalVisible(true);
    };
    // Submit logic for creating/updating a city
    const handleSubmit = async (cityData) => {
        try {
            setErrors(null);
            if (selectedCity && cityData.id) {
                await handleUpdateCity({ id: cityData.id, city: cityData });
                toast.success("Modifications enregistrées");
            }
            else {
                await handleAddCity(cityData);
                toast.success("Ville enregistrée avec succès");
            }
            setIsModalVisible(false);
        }
        catch (error) {
            console.error("Erreur lors de la sauvegarde de la ville :", error);
            setErrors(error.message);
            toast.error(`Erreur : ${error.message}`);
        }
    };
    // Loading and error states
    if (loading) {
        return _jsx("div", { className: "p-4", children: "Chargement des villes..." });
    }
    if (error) {
        return (_jsxs("div", { className: "p-4 text-red-500", children: ["Erreur lors du chargement des villes : ", error, _jsx("button", { onClick: () => refetchCities(), className: "ml-4 bg-blue-500 text-white px-2 py-1 rounded", children: "R\u00E9essayer" })] }));
    }
    return (_jsxs("div", { className: "p-4 bg-gray-50 min-h-screen", children: [_jsx("div", { className: "flex flex-col sm:flex-row justify-end", children: _jsx("button", { onClick: handleAddCityClick, className: "mb-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600", children: "+ Ajouter une ville" }) }), _jsx(CityTableFilters, { filters: filters, onFilterChange: handleFilterChange, onResetFilters: handleResetFilters }), _jsx(CityTable, { cities: cities, onEdit: handleEdit, onDelete: (id) => handleDelete(id) }), meta && (_jsx(CityPagination, { currentPage: meta.page ?? 1, totalPages: meta.totalPages ?? 1, limit: rowsPerPage, onPageChange: (page) => setCurrentPage(page), onLimitChange: (value) => {
                    setRowsPerPage(value);
                    setCurrentPage(1);
                } })), isModalVisible && (_jsx(Modal, { onClose: () => setIsModalVisible(false), children: _jsx(CityForm, { initialData: selectedCity ?? undefined, regions: regions, onSubmit: handleSubmit, onCancel: () => setIsModalVisible(false) }) })), errors && (_jsxs("div", { className: "mt-4 p-3 bg-red-100 text-red-700 rounded", children: ["Erreur : ", errors] }))] }));
};
export default CitiesPage;
